<template>
  <div class="messageCenter clearfix">
    <div class="titleBox mb-4">
      <h2 class="m-0">
        <span>我的消息</span>
        <button @click='toBack' class="btn btn-outline-dark btn-round d-block d-lg-none">商城 <i class="iconfont icon-qianwang"></i></button>
      </h2>
      <hr>
      <p class="content">
        所有的消息都在这里！
      </p>
    </div>

    <div class="jiazaiBox" v-if="intLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="threeBox" v-if="!intLoading">
      <div v-if="!is_loading">
        <div class="liebiaoBox">
          <ul v-for="(app,index) in data" :key="index">
            <li>{{app.title}}</li>
            <li v-for="(apps,indexs) in app.child" :key="indexs">
              <span class="text-primary">{{apps.addtime_md}}：</span>
              {{apps.message}}
            </li>
          </ul>
        </div>
        <br>
        <div class="description text-center">
          <div v-if='isLoading && page!==1' class='dynamicMessage'>
            <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
          </div>
          <div v-if='isNodata || page>=allPage' class='dynamicMessage yemaBox'>
            <span>提示：没有更多了数据了...</span>
            <span>共{{allNumber}}条数据,{{page>allPage?allPage:page}}/{{allPage}}页</span>
          </div>
          <div v-if='isError' class='dynamicMessage'>
            — 请求失败 —
          </div>
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import commons from '@/util/commons';

export default {
  name: 'messageCenter',
  mixins: [generalMix],
  data () {
    return {
      // 分页
      data: [], // 数据队列
      allPage: 1, // 总页数
      allNumber: 0,
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      intLoading: true, // 初始化加载
      anliArr:[],
      is_loading:false
    }
  },
  computed:{
    whereObj() {
      return {
        page: this.page
      };
    }
  },
  methods:{
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
      }
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = commons.scrollToButton() <= 150;
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          const whereJson = that.whereObj;
          resultCommons.apiCrmdatamessagelists(that, whereJson).then((ob) => {
            console.log(ob, this.page);
          });
        }
      };
    },
    initData(bool = false){
      // 判断是否有时间筛选
      // eslint-disable-next-line no-constant-condition
      if(false){
        this.$message.showMsgBox({
          type: 'warning',
          content: '时间条件需为时间段'
        });
      }else{
        if(bool){
          this.intLoading = true;
        }
        // 执行搜索
        this.loadingFun(2);
        // 初始化
        this.data = [];
        this.allPage = 1;
        this.page = 1;
        // 不为空
        this.is_empty = false;
        const whereJson = this.whereObj;
        // 执行搜索
        resultCommons.apiCrmdatamessagelists(this, whereJson).then((ob) => {}).then(app=>{
          if(bool){
            this.intLoading = false;
          }
        });
      }
    }
  },
  created() {
  },
  components: {
  },
  mounted() {
    this.initData(true);
    this.scroll(this, window);
    $('html').removeClass('scrollHide');
  },
  beforeDestroy() {
    // 清除事件
    window.onscroll = null;
  }
}
</script>

<style scoped lang='less'>
.messageCenter {
  .titleBox {
    margin-top: 30px;
    margin-bottom: 30px;
    p {
      margin: 0;
    }
  }
  div.searchBox{
    display: flex;
    div.box{
      flex: 1;
      input{
        line-height: 45px;
        height: 45px;
        //width: 260px;
      }
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    min-height: 250px;
    .spinner-border{
      width: 3rem;
      height: 3rem;
      color: red;
    }
  }
  div.liebiaoBox{
    background: #FFFFFF;
    border-radius: 5px;
    padding: 25px;
    ul{
      margin-bottom: 10px;
      li{
        line-height: 2em;
        border-bottom: 1px solid #EFF2F7;
        padding: 10px 0;
        display: flex;
        span{
          font-weight: bold;
        }
        &:first-child{
          font-weight: bold;
          font-size: 22px;
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .messageCenter{
  }
}
@media (max-width: 992px) {
  .messageCenter{
    .titleBox {
      margin-top: 0;
      h2{
        display: flex;
        justify-content: space-between;
      }
      p {
        margin: 0;
        color: #9B9B9B;
      }
    }
  }
}
@media (max-width: 767px) {
  .homeCenter{
    .titleBox {
      p{
        padding: 0 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message/Center.vue